import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetImpactRatingCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetImpactRatingCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetImpactRatingCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    impact_rating_aggregate: { aggregate: toAggregate(data.impactRating) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetImpactRatingCountDocument,
});
